module.exports = __webpack_public_path__ + "img/officehome2.5ada8627.webp";